import { InboxFilters, InboxPage } from '@frontend/features/inbox/types';
import { dedupeInboxItems } from '@frontend/features/inbox/listModel';

export type NotificationCenterTab = 'conversations' | 'activity';

export const unreadConversationFilters: InboxFilters = {
  search: '',
  agencies: [],
  assignment: 'mine',
  workflowIds: [],
  stepIds: [],
  unreadOnly: true,
};

export const notificationCenterBadgeCount = (
  hasInboxAccess: boolean,
  unreadCaseCount: number,
  legacyNotificationCount: string | number | undefined,
) => (hasInboxAccess ? unreadCaseCount : Number(legacyNotificationCount || 0));

export const unreadConversationItems = (pages: InboxPage[] | undefined) => dedupeInboxItems(pages ?? []);
